import { useEffect, useRef } from "react";
import "./WelcomeHomePopup.css";
import { HiXMark } from "react-icons/hi2";

const WelcomeHomePopup = ({ show, onClose }) => {
    const popupRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (popupRef.current && !popupRef.current.contains(e.target)) {
                onClose();
            }
        };

        if (show) {
            document.body.style.overflow = "hidden";
            document.body.style.overflowX = "hidden";
            document.documentElement.style.overflow = "hidden";

            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.body.style.overflow = "";
            document.body.style.overflowX = "";
            document.documentElement.style.overflow = "";

            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [show, onClose]);

    const handleBannerClick = () => {
        onClose();

        window.location.href =
            "https://business.ghayar.com/Spare-Parts/PartsByBrand/475-BORG%20%26%20BECK";
    };

    if (!show) return null;

    return (
        <div className="welcome-home-popup-overlay">
            <div
                ref={popupRef}
                className="welcome-home-popup-box"
            >
                <button
                    className="welcome-home-popup-close-btn"
                    onClick={onClose}
                >
                    <HiXMark
                        style={{
                            width: "25px",
                            height: "25px",
                            strokeWidth: 1,
                        }}
                    />
                </button>

                <img
                    src="/assets/images/social_media/main_banner.jpeg"
                    alt="Welcome Banner"
                    className="welcome-home-popup-image"
                    onClick={handleBannerClick}
                />
            </div>
        </div>
    );
};

export default WelcomeHomePopup;